export const refs = {
  searchInput: document.querySelector('.js-search-control'),
  linkMyLibrary: document.querySelector('.js-lib_page'),
  linkHome: document.querySelector('.js-home_page'),
  logoHome: document.querySelector('.js-logo'),
  home: document.querySelector('#home'),
  watchedLibrary: document.querySelector('.js-btn_watched'),
  queueLibrary: document.querySelector('.js-btn_queue'),
  aboutTeam: document.querySelector('.js-link-footer'),
  galleryList: document.querySelector('.js-gallery-list'),
  buttonScrollUp: document.querySelector('.js-buttonScrollUp'),
  spinnerPreloader: document.querySelector('.js-preloader-page'),
  modalBackdrop: document.querySelector('.js-backdrop'),
  modalCloseBtn: document.querySelector('.js-close-btn'),
  modal: document.querySelector('.js-modal'),
  searchForm: document.querySelector('.js-search-form'),
  cardContainer: document.querySelector('.card-container'),

  header: document.querySelector('.js-header'),
  headerButtons: document.querySelector('.js-buttons'),
  headerNavigation: document.querySelector('.js-header-nav'),
  movieGallerySection: document.querySelector('.movie-gallery-js'),
  divFilter: document.querySelector('.divForFilters'),
  select: document.querySelector('.js-select'),
  anchor: document.querySelector('.anchor'),
  trailerBackdrop: document.querySelector('.js-backdrop-trailer'),
  trailerIframe: document.querySelector('.js-trailer'),
};
